import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../../utils/numberUtils';

const CostSummary = ({
  chance,
  totalPurchase,
  totalSales,
  totalProfit,
  totalMargin,
}) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
    >
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매출액
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalSales
            ? getNumberComma(chance.totalSales)
            : getNumberComma(totalSales)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매입액
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalPurchase
            ? getNumberComma(chance.totalPurchase)
            : getNumberComma(totalPurchase)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매출이익
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalProfit
            ? getNumberComma(chance?.totalProfit)
            : getNumberComma(totalProfit)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          이익율
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.expBenefitRate !== undefined
            ? `${chance?.expBenefitRate} %`
            : `${totalMargin} %`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CostSummary;
